import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';

@Component({
  selector: 'app-kendo-editor-form-field',
  templateUrl: './kendo-editor-form-field.component.html',
  styleUrls: ['./kendo-editor-form-field.component.scss']
})
export class KendoEditorFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  
  public fontData = [
    { text: "8", size: "8pt" },
    { text: "9", size: "9pt" },
    { text: "10", size: "10pt" },
    { text: "11", size: "11pt" },
    { text: "12", size: "12pt" },
    { text: "14", size: "14pt" },
    { text: "16", size: "16pt" },
    { text: "18", size: "18pt" },
    { text: "20", size: "20pt" },
    { text: "22", size: "22pt" },
    { text: "24", size: "24pt" },
    { text: "26", size: "26pt" },
    { text: "28", size: "28pt" },
    { text: "36", size: "36pt" },
    { text: "48", size: "48pt" },
    { text: "72", size: "72pt" },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
